import { createSlice, createEntityAdapter } from "@reduxjs/toolkit";

import { doGetAllLabels, doCreateLabel, doUpdateLabel, doDeleteLabel } from "./thunk";

const isActionWithPending = action => {
  return action.type.endsWith("/pending") && !action.type.includes("NoFetching");
};

const isActionWithFulfilled = action => {
  return action.type.endsWith("/fulfilled");
};

const isActionWithFailed = action => {
  return action.type.endsWith("/rejected");
};

const labelsAdapter = createEntityAdapter({
  selectId: item => item._id,
  sortComparer: (a, b) => b.createdAt.localeCompare(a.createdAt),
});

const labelSlice = createSlice({
  name: "label",
  initialState: {
    isFetching: false,
    metadata: {},
    entities: [],
    ids: [],
  },
  reducers: {},
  extraReducers: builder => {
    builder.addCase(doGetAllLabels.fulfilled, (state, action) => {
      const { labels, meta } = action.payload;
      state.metadata = meta;
      labelsAdapter.setAll(state, labels);
    });
    builder.addCase(doCreateLabel.fulfilled, (state, action) => {
      labelsAdapter.upsertOne(state, action.payload);
    });
    builder.addCase(doUpdateLabel.fulfilled, (state, action) => {
      labelsAdapter.upsertOne(state, action.payload);
    });
    builder.addCase(doDeleteLabel.fulfilled, (state, action) => {
      labelsAdapter.removeOne(state, action.meta.arg);
    });
    builder.addMatcher(isActionWithPending, state => {
      state.isFetching = true;
    });
    builder.addMatcher(isActionWithFulfilled, state => {
      state.isFetching = false;
    });
    builder.addMatcher(isActionWithFailed, state => {
      state.isFetching = false;
    });
  },
});

export const {
  selectAll: selectAllLabels,
  selectById: selectLabelById,
  selectIds: selectlabelIds,
} = labelsAdapter.getSelectors(state => state.label);

const { reducer: labelReducer } = labelSlice;
export default labelReducer;
